import React, { useState } from 'react';
import { Paper, Typography, Button, IconButton, Tooltip } from '@mui/material';
import { Lock as LockIcon, Close as CloseIcon } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { useAppData } from '../../contexts/AppDataContext';
import { useNavigate } from 'react-router-dom';
import SimpleChat from './SimpleChat';

/**
 * Wrapper component that only shows chat when user is authenticated and on a paid plan.
 * Free / no-org users see a minimizable upgrade prompt instead.
 */
const ChatWrapper = () => {
  const { user } = useAuth();
  const { organizations, initialized } = useAppData();
  const navigate = useNavigate();
  const [isMinimized, setIsMinimized] = useState(true);

  if (!user || !initialized) return null;

  // User has a paid plan if any of their orgs has is_paid=true
  const hasPaidPlan = organizations.some((org) => org.is_paid);

  if (!hasPaidPlan) {
    if (isMinimized) {
      return (
        <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
          <Tooltip title="AI Assistant — upgrade to unlock" placement="left">
            <button
              onClick={() => setIsMinimized(false)}
              style={{
                backgroundColor: '#9e9e9e',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '60px',
                height: '60px',
                fontSize: '24px',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              }}
            >
              💬
            </button>
          </Tooltip>
        </div>
      );
    }

    return (
      <Paper
        elevation={3}
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          width: 280,
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
          zIndex: 1300,
          textAlign: 'center',
        }}
      >
        <IconButton
          size="small"
          onClick={() => setIsMinimized(true)}
          sx={{ position: 'absolute', top: 4, right: 4 }}
          aria-label="Minimize"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <LockIcon color="action" sx={{ mt: 1 }} />
        <Typography variant="subtitle2">AI Assistant</Typography>
        <Typography variant="caption" color="text.secondary">
          Upgrade to a paid plan to access the AI assistant.
        </Typography>
        <Button
          variant="contained"
          size="small"
          onClick={() => navigate('/pricing')}
        >
          Upgrade
        </Button>
      </Paper>
    );
  }

  return <SimpleChat />;
};

export default ChatWrapper;
